var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.5H7.5C6.94772 6.5 6.5 6.94772 6.5 7.5V13.5C6.5 14.0523 6.94772 14.5 7.5 14.5H13.5C14.0523 14.5 14.5 14.0523 14.5 13.5V7.5C14.5 6.94772 14.0523 6.5 13.5 6.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.825 5.77911L17.7789 9.82518C17.4064 10.1977 17.4064 10.8018 17.7789 11.1743L21.825 15.2204C22.1975 15.593 22.8016 15.593 23.1741 15.2204L27.2202 11.1743C27.5928 10.8018 27.5928 10.1977 27.2202 9.82518L23.1741 5.77911C22.8016 5.40655 22.1975 5.40655 21.825 5.77911Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.5H19.5C18.9477 18.5 18.5 18.9477 18.5 19.5V25.5C18.5 26.0523 18.9477 26.5 19.5 26.5H25.5C26.0523 26.5 26.5 26.0523 26.5 25.5V19.5C26.5 18.9477 26.0523 18.5 25.5 18.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5H7.5C6.94772 18.5 6.5 18.9477 6.5 19.5V25.5C6.5 26.0523 6.94772 26.5 7.5 26.5H13.5C14.0523 26.5 14.5 26.0523 14.5 25.5V19.5C14.5 18.9477 14.0523 18.5 13.5 18.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate);
export default __webpack_public_path__ + "static/media/Template.76d469e0b9f78b68e5ea7e3ae2cadc04.svg";
export { ForwardRef as ReactComponent };